import { handleActions } from 'redux-actions';
import { getPatientTemplatesRoutine, getTemplatesRoutine } from './routines';
import { combineReducers } from 'redux';

const initialState = {
  folders_images_templates: {
    result: [],
    error: null,
    loading: false,
  },
  images_templates: {
    result: [],
    error: null,
    loading: false,
  },

};

console.log('getPatientTemplatesRoutine', getPatientTemplatesRoutine)

const foldersImagesTemplatesReducer = handleActions(
  {
    [getPatientTemplatesRoutine.TRIGGER]: (state) => ({
        ...state,
        loading: true,
    }),

    [getPatientTemplatesRoutine.SUCCESS]: (state, action) => ({
      ...state,
      result: action.payload.result
    }),

    [getPatientTemplatesRoutine.FAILURE]: (state, action) => ({
      ...state,
      error: action.payload,
    }),

    [getPatientTemplatesRoutine.FULFILL]: (state) => ({
      ...state,
      loading: false
    }),
  },
  initialState.folders_images_templates
)

const imagesTemplatesReducer = handleActions(
  {
     [getTemplatesRoutine.TRIGGER]: (state) => ({
        ...state,
        loading: true,
    }),

    [getTemplatesRoutine.SUCCESS]: (state, action) => ({
      ...state,
      result: action.payload.result
    }),

    [getTemplatesRoutine.FAILURE]: (state, action) => ({
      ...state,
      error: action.payload,
    }),

    [getTemplatesRoutine.FULFILL]: (state) => ({
      ...state,
      loading: false
    }),
  },
  initialState.images_templates
);


export const patientTemplatesReducer = combineReducers({
  folders_images_templates: foldersImagesTemplatesReducer,
  images_templates: imagesTemplatesReducer,
})